import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { registerServiceWorker } from '@/services/pwa';
import { createQueryClient } from './lib/queryClient';
import { ensureLanguage } from '@/i18n';
import { useUiStore } from '@/store';
import './index.css';

const queryClient = createQueryClient();

/**
 * V-98. Lithuanian is compiled in; any other language is fetched here,
 * before the first paint, so nobody ever reads a screen in the wrong
 * language for a beat. The store has already rehydrated from localStorage by
 * the time this module runs, so `lang` is the one this dispatcher last
 * chose, not the default.
 *
 * For Lithuanian — which is every carrier this product is sold to — nothing
 * is fetched and this resolves on the next microtask. English costs one
 * request that used to be 34,9 KiB gzip inside the shared chunk, paid by
 * everyone.
 */
ensureLanguage(useUiStore.getState().lang).finally(() => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );

  registerServiceWorker();
});
